module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00027-fs8.4799636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00027-fs8.png
// module id = 180
// module chunks = 0